;(function () {
    "use strict";

    var bindEvents = function ($el) {

        // Init for when accept button is present.
        if (hasButton($el)) {
            // Set listener for pressing accept button.
            getButton($el).on('click', function () {
                setCookie(true);
                $($el).hide();
            });
        }
        // Init for when accept button is NOT present.
        else {
            // Set listener for moving page or moving around on site
            document.addEventListener('scroll', function () {
                setCookie();
                $($el).hide();
            });
        }

        window.addEventListener('beforeunload', function () {
            setCookie(isAccepted());
        });
    };

    var init = function ($el) {
        // Don't show notfication if accepted already.
        if (hasButton($el)) {
            if (isAccepted()) {
                return;
            }
        }

        // Don't show notification if seen already.
        else if (isSeen()) {
            return;
        }

        // Show gdpr notification.
        $($el).show();
        bindEvents($el);
    };

    var isSeen = function () {
        return document.cookie.indexOf('gdpr-notification=') >= 0;
    };

    var isAccepted = function () {
        return document.cookie.indexOf('gdpr-notification=accepted') >= 0;
    };

    var getButton = function ($el) {
        return $($el).find('.gdpr-notification-content-form button');
    };

    var hasButton = function ($el) {
        return !!getButton($el).length;
    };

    var setCookie = function (accepted) {
        var cookieDate = new Date;
        var cookieContent = accepted ? 'accepted' : 'seen';
        cookieDate.setFullYear(cookieDate.getFullYear() + 1);
        document.cookie = 'gdpr-notification=' + cookieContent + '; expires=' + cookieDate.toGMTString() + '; path=/';
    };
    
    var elem = document.getElementById('gdpr-notification');
    if (elem) {
        init(elem);
    }
})();